export * from './secondary-topic-modal.component';


// WEBPACK FOOTER //
// ./src/app/shared/components/metadata-menu/topic/secondary-topic-modal/index.ts